import React from "react";

function Confirmation({ data, course, onClose }) {
  console.log("Confirmation", data);
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md text-center">
        <h2 className="text-2xl font-semibold mb-4">Booking Confirmed!</h2>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Thanks for booking. Our team will get back to you.
        </button>
      </div>
    </div>
  );
}

export default Confirmation;
